import { SHOWMODAL, REMOVE_MODAL, ERROR_NOT_CONTROLED, ERROR_NOT_CONTROLED_CLEAR } from "../actions/constantsActions";
import $ from 'jquery';

const initialState = {
  modalsVisible: [],
  genericError: false,
  genericMessage: null,
};

const CHANGE_ROUTE = '@@router/LOCATION_CHANGE';

const ACTION_HANDLERS = {
  [SHOWMODAL]: (state, action) => {
    setTimeout(() => $('.modal[tabIndex]').removeAttr('tabIndex'), 500);
    return {
      modalsVisible: state.modalsVisible.concat(action.modal)
    };
  },

  [REMOVE_MODAL]: (state, action) => {
    const modalsVisible = state.modalsVisible.filter(modal => {
      modal.modalType = action.modalType;
    });
    return { modalsVisible };
  },

  [CHANGE_ROUTE]: (state, action) => { // hide all modals on route change
    return initialState;
  },
  [ERROR_NOT_CONTROLED]: (state, action) => {
    return {
      ...initialState,
      genericError: true,
      genericMessage: action.payload,
    };
  },
  [ERROR_NOT_CONTROLED_CLEAR]: (state, action) => {
    return {...initialState, genericError: false, genericMessage: null};
  },
}

export default function showModal(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
